import React from "react";
const ILabelCheck = ({iid,children}) => {
    
    return (  
        <label className="form-check-label" htmlFor={iid}>{children}</label>
    );
}
 
export default ILabelCheck;
